import { Box, Text, useColorModeValue, VStack } from '@chakra-ui/react';
import { UploadIcon2 } from '@assets/icons';
import { FileUploader } from 'react-drag-drop-files';
import { useFileUploadPopUp } from '@store/useFileUploadPopUp';

export default function FileUploadField() {
    const { set, maxFileSize, isFileError } = useFileUploadPopUp();
    const fileTypeAllowed = ['xls', 'xlsx', 'csv', 'pdf'];
    const fileTypeMapping = fileTypeAllowed.map((ext) => ext.toUpperCase()).join(', ');

    return (
        <FileUploader
            handleChange={(selectedFile) => {
                set({ isFileError: false, files: [selectedFile] });
            }}
            onTypeError={(err) => {
                const message = `Format file yang diperbolehkan hanya ${fileTypeAllowed
                    .map((f) => `.${f.toUpperCase()}`)
                    .join(', ')
                    .replace(/, ([^,]*)$/, ' atau $1')}.`;
                set({ files: null, isFileError: message });
            }}
            onSizeError={(err) => {
                set({
                    files: null,
                    isFileError: `Ukuran file yang dipilih melebihi batas maksimum ${maxFileSize} MB.`,
                });
            }}
            types={fileTypeAllowed}
            maxSize={maxFileSize}
        >
            <Box>
                <Box
                    border="3px dashed"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    borderRadius="8px"
                    p={'40px'}
                    cursor="pointer"
                    _hover={{ bg: 'semantic.200' }}
                    transition="background 0.2s"
                >
                    <VStack spacing={2}>
                        <UploadIcon2 size={28} color="#C2C2C2" />
                        <Text fontSize={'16px'} color={'neutral.500'} mb={'16px'} pt={'16px'}>
                            Drag and drop file disini, atau{' '}
                            <Box display={'inline'} color={'paragon.500'}>
                                Pilih File
                            </Box>
                        </Text>
                        <Text fontSize={'12px'} color={'neutral.400'}>
                            Format file didukung: {fileTypeMapping} (Maks. {maxFileSize} Mb)
                        </Text>
                    </VStack>
                </Box>

                {isFileError && (
                    <Text fontSize={'12px'} color={'danger.600'} mt={'12px'}>
                        {isFileError}
                    </Text>
                )}
            </Box>
        </FileUploader>
    );
}
